const CONNECTION_TYPES = {
    BLE: 0,
    USB: 1,
};

let connectionType = CONNECTION_TYPES.BLE;

const setIsUsb = () => (connectionType = CONNECTION_TYPES.USB);
const setIsBle = () => (connectionType = CONNECTION_TYPES.BLE);
const resetConnectionType = () => (connectionType = CONNECTION_TYPES.BLE);
const getConnectionType = (type) => connectionType === type;

const isUsb = () => getConnectionType(CONNECTION_TYPES.USB);
const isBle = () => getConnectionType(CONNECTION_TYPES.BLE);

const getConnectionTypeName = () => (isBle() ? 'BLE' : 'USBHID');

export default {
    getConnectionTypeName,
    isBle,
    isUsb,
    resetConnectionType,
    setIsBle,
    setIsUsb,
};
